import React from 'react';
import { Button, RiSaveLine } from '@itandi/itandi-bb-ui';
import { useFormContext } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import Styles from '../../../../../common/deals/new/DealEditorFooter.module.scss';
import type { Deal } from '~/models/Deal';
import type { RelatedDealParam } from '~/models/DealForm';
import { create } from '~/utils/api/deals/RelatedDeal';
import { isSuccess } from '~/utils/api/api_handler';
import { PATH } from '~/pages/deals/[id]';
import useLoader from '~/hooks/useLoader';
import { onInvalidScroll } from '~/utils/FormUtil';

type Props = {
  deal: Deal;
};

export const DealEditorFooter: React.FC<Props> = ({ deal }) => {
  const router = useRouter();
  const { getValues, handleSubmit } = useFormContext<RelatedDealParam>();
  const { Loader, showLoader, hideLoader } = useLoader();
  const onClickSubmit = React.useCallback(() => {
    handleSubmit(
      async () => {
        showLoader();
        const response = await create(getValues(), deal.id);
        if (isSuccess(response) && response.data?.id != null) {
          await router.push(PATH(response.data.id));
          toast.success('作成しました。');
        } else {
          toast.error('エラーが発生しました。');
        }
        hideLoader();
      },
      (errors) => onInvalidScroll(errors)
    )();
  }, [handleSubmit, showLoader, getValues, hideLoader, router, deal]);
  return (
    <div className={Styles.DealEditorFooter}>
      <Loader />
      <Button
        className={Styles.SaveButton}
        onClick={onClickSubmit}
        startIcon={<RiSaveLine className={Styles.Icon} />}
        variant="primary"
      >
        保存
      </Button>
    </div>
  );
};
